// extracted by mini-css-extract-plugin
export var chevron = "_35-d";
export var disabled = "_35-b";
export var error = "_35-c";
export var hideBorder = "_35-1";
export var icon = "_35-e";
export var input = "_35-0";
export var open = "_35-9";
export var placeholder = "_35-a";
export var regular = "_35-5";
export var singleRowInput = "_35-2";
export var singleSelectInput = "_35-3 _35-0";
export var small = "_35-4";
export var spinnerContainer = "_35-g";
export var tag = "_35-7";
export var tagsContainer = "_35-8";
export var tagsInput = "_35-6 _35-0";
export var xSmall = "_35-f";